import { gql } from '@apollo/client';

export const CREATE_TRAJECTORY_MODEL = gql`
    mutation createTrajectoryModel($input: CreateTrajectoryConfigurationInput!) {
        facility {
            modelConfigurations {
                trajectoryConfigurations {
                    createTrajectoryConfiguration(input: $input) {
                        id
                        name
                        description
                        type
                        isBlasting
                        runs {
                            id
                            key
                        }
                        calmetConfigurations {
                            id
                            name
                            description
                            sourceForTypes
                            timeStep
                            isForecast
                        }
                    }
                }
            }
        }
    }
`;
